var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LightboxContentLayout',{attrs:{"accessibilityText":_vm.data.accessibility_text,"ariaDescription":_vm.ariaDescription,"captionText":_vm.data.caption,"accessibilityTextFlag":_vm.accessibilityTextFlag}},[_c('v-img',{style:({
    width: '100%',
    height: '100%',
  }),attrs:{"role":"img","src":_vm.image,"contain":true,"title":_vm.data.alternative_text,"aria-describedby":this.ariaDescription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }